import React from 'react';
import axios from 'axios'
import { Table, Input, Button,Collapse,Popover,Popconfirm,message,Spin,Tabs } from 'antd';
import Highlighter from 'react-highlight-words';
import Icon from '@ant-design/icons';
import { SearchOutlined,DeleteOutlined,FundViewOutlined,LoadingOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import * as serverconfig from '../serverconn'
import ActionWorkFlowMappingForm from '../components/ActionWorkFlowMappingForm';
import CompanyUpdateForm from '../components/CompanyUpdateForm';
import ActionWorkFlowMappingUpdateForm from '../components/ActionWorkFlowMappingUpdateForm';
import TriggersList from './Triggers';

var CryptoJS = require("crypto-js");

const { Panel } = Collapse;
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;

function callback(key) {
  console.log(key);
}
const { TabPane } = Tabs;


var token= ''
var bizuserid= ''


class WorkFlowActionMapping extends React.Component {
  state = {
    searchText: '',
    searchedColumn: '',
    actionworkflowmappings: [],
    datarequested:true,
    workflow_id:'',
    expanded:false

  };

  componentDidMount(){
    this.comp_reloaded()
    
}

comp_reloaded=()=>{
  this.setState({workflow_id:this.props.workflow_id})

  if(localStorage.getItem("token")){
     token= localStorage.getItem("token")
  }else{
     token= ''
  }

  if(localStorage.getItem("bizuserid")){
    bizuserid= CryptoJS.AES.decrypt(localStorage.getItem("bizuserid") , 'my-secret-key@1234').toString(CryptoJS.enc.Utf8)
 }else{
    bizuserid= ''
 }

  axios.defaults.headers={
    "Content-Type":"application/json",
    Authorization:`Token ${token}`
  }

  axios.get(serverconfig.backendserverurl+`/api/actionworkflowmappings/?workflow=${this.props.workflow_id}`)
  .then(res => {
      this.setState({
        actionworkflowmappings:res.data
      })

      this.setState({datarequested:false})
  })

}


getColumnSearchProps = dataIndex => ({
  filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
    <div style={{ padding: 8 }}>
      <Input
        ref={node => {
          this.searchInput = node;
        }}
        placeholder={`Search ${dataIndex}`}
        value={selectedKeys[0]}
        onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
        onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
        style={{ width: 188, marginBottom: 8, display: 'block' }}
      />
      <Button
        type="primary"
        onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
        icon={<SearchOutlined />}
        size="small"
        style={{ width: 90, marginRight: 8 }}
      >
        Search
      </Button>
      <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
        Reset
      </Button>
    </div>
  ),
  filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />,
  onFilter: (value, record) =>
    record[dataIndex]
      .toString()
      .toLowerCase()
      .includes(value.toLowerCase()),
  onFilterDropdownVisibleChange: visible => {
    if (visible) {
      setTimeout(() => this.searchInput.select());
    }
  },
  render: text =>
    this.state.searchedColumn === dataIndex ? (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[this.state.searchText]}
        autoEscape
        textToHighlight={text.toString()}
      />
    ) : (
      text
    ),
});

handleSearch = (selectedKeys, confirm, dataIndex) => {
  confirm();
  this.setState({
    searchText: selectedKeys[0],
    searchedColumn: dataIndex,
  });
};

handleReset = clearFilters => {
  clearFilters();
  this.setState({ searchText: '' });
};


  render() {
    
    const columns = [
    
      {
        title: 'Order',
        dataIndex: 'order',
        key: 'id',
      },
     
      {
        title: 'Action',
        dataIndex: 'action_name',
        key: 'id',
        ...this.getColumnSearchProps('action_name'),
      },
      {
        title: 'Action Description',
        dataIndex: 'action_description',
        key: 'id',
      },

      {
        title: 'Responsible Roles',
        dataIndex: 'responsible_roles',
        key: 'id',
      },

      {
        title: 'Application Status(Postive Outcome)',
        dataIndex: 'positive_application_status',
        key: 'id',
      },

      {
        title: 'Application Status(Negative Outcome)',
        dataIndex: 'negative_application_status',
        key: 'id',
      },

      {
        title: 'Auto triggered?',
        dataIndex: 'action_auto_trigger',
        key: 'id',
        render: (text,record) =>
          <p>
            {record.action_auto_trigger===true?"Yes":"No"}
          </p>,
      }
          
    ];

    if(this.state.datarequested===true){
      return(
        <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
              <Spin size="large">
                <div className="content" />
              </Spin>      
         </div>
      )

    }else{
      return(
        <div>

          <Tabs
            defaultActiveKey="1"
            onChange={() => {}}
            tabPosition={'top'}
          >
              <TabPane tab={"Action steps/Business Rules"} key="1">
                    <p>There are {this.state.actionworkflowmappings.length} Actions in the list </p>
                      <Table 
                        columns={columns} 
                        scroll={{ x: 1000 }}
                        pagination={{showQuickJumper:true,showSizeChanger:true }}
                        dataSource={this.state.actionworkflowmappings}
                        bordered
                        
                        expandable={{
                          expandedRowRender: (record) =>{
                              return (
                                <div>

                                  <Tabs
                                    defaultActiveKey="1"
                                    onChange={() => {}}
                                    tabPosition={'top'}
                                  >

                                  {
                                    this.state.expanded===true?
                                    <TabPane tab={"Update/Details "} key="1">
                                    <ActionWorkFlowMappingUpdateForm mapping={record} onRefresh={this.comp_reloaded} />
                                    </TabPane>                                    
                                    :
                                    null
                                  }  

                                  <TabPane tab={" Triggers "} key="2">
                                    <TriggersList mapping_obj={record}/>
                                  </TabPane>

                                  </Tabs>

                                </div>
                              );
                          } ,
                          rowExpandable: (record) => true,
                          onExpand:(condition,record)=>{
                            this.setState({expanded:!this.state.expanded})
                          },
                        }}
                        
                        />
              </TabPane>

              <TabPane tab={"Action Mapping Form"} key="2">
                <ActionWorkFlowMappingForm  workflow_id={this.state.workflow_id}  onRefresh={this.comp_reloaded}/>
              </TabPane>
              </Tabs>

        </div>)

    }

   
  }
}

export default WorkFlowActionMapping; 
